import { usePageTitle } from '@calendly/hooks';
import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { withSafeSuspense } from '@calendly/safe-suspense';
import { FlexLayout } from '@calendly/ui/components/flex-layout';
import { TitleText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { lazy, useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DOMAIN_CONTROL } from 'constants/billing_features';
import { isAvailableFeatureSelector } from 'features/billing';
import { Description } from '../styles';
import { DomainCards } from './cards/cards';
import { DeleteDomainPopup } from './delete_domain_popup';
import { DomainControlSettings } from './domain_control_settings/domain_control_settings';
import { EnableDomainControlPopup } from './enable_domain_control_popup';
import { Paywall } from './paywall';
import { OnboardingGuideLink } from './shared_components/info_links';
import { reset } from './slice';

/**
 Lazy-load the component CreateDomainControl only when it's necessary or needed.
 This component uses second_level_domains.yml that uses more than 30kb in disk (before gzip).
*/
const CreateDomainControlContent = lazy(async () => {
  const {
    CreateDomainControl
  } = await import('./create_domain_control.js');
  return {
    default: CreateDomainControl
  };
});
const CreateDomainControl = withSafeSuspense(CreateDomainControlContent);
const dividerCss = "d79wr1u";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'hr';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)} />;
});
export const DomainControl = () => {
  const dispatch = useDispatch();
  const seePaywall = !useSelector(state => isAvailableFeatureSelector(state, {
    featureKey: DOMAIN_CONTROL
  }));
  const pageTitlePostfix = I18n.t('publisher.admin.login.title');
  usePageTitle(`${I18n.t('publisher.admin.login.tabs.domain_control')} - ${pageTitlePostfix}`);
  useEffect(() => () => dispatch(reset()), [dispatch]);
  if (seePaywall) {
    return <Paywall />;
  }
  return <>
      <FlexLayout direction="column" gap="16">
        <TitleText level={2} size="medium">{I18n.t('publisher.organization_settings.domain_control.title')}</TitleText>
        <Description>
          {HtmlParser(I18n.t('publisher.organization_settings.domain_control.description'), {
          OnboardingGuideLink
        })}
        </Description>
      </FlexLayout>
      <CreateDomainControl />
      <DomainCards />
      <Divider />
      <DomainControlSettings />
      <DeleteDomainPopup />
      <EnableDomainControlPopup />
    </>;
};

require("./domain_control.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./domain_control.js");